import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiMessageCircle } = FiIcons;

export default function WhatsAppWidget() {
  const [showTooltip, setShowTooltip] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setShowTooltip(true), 4000);
    return () => clearTimeout(timer);
  }, []);

  const whatsappLink = "https://link.ajedolabomi.com/whatsapp-help";

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      <AnimatePresence>
        {showTooltip && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            className="bg-gray-900 text-white px-4 py-3 rounded-2xl shadow-2xl text-sm font-semibold mb-2 relative"
          >
            I'll help you step-by-step! 👋
            <div className="absolute -bottom-1 right-6 w-3 h-3 bg-gray-900 rotate-45"></div>
          </motion.div>
        )}
      </AnimatePresence>

      <motion.button
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={() => window.open(whatsappLink, '_blank')}
        className="w-16 h-16 bg-emerald-500 text-white rounded-full flex items-center justify-center shadow-[0_10px_40px_rgba(16,185,129,0.4)] relative group"
      >
        <span className="absolute inset-0 rounded-full bg-emerald-400 animate-ping opacity-20"></span>
        <SafeIcon icon={FiMessageCircle} className="text-3xl" />
      </motion.button>
    </div>
  );
}